import { onError } from "@apollo/client/link/error";
import logAnalyticsEvent from "../firebase/analytics/logAnalyticsEvent";

export default () =>
  onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        logAnalyticsEvent("graphql_error", {
          message,
          locations,
          path
        });
        // eslint-disable-next-line no-console
        return console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        );
      });
    }
    if (networkError) {
      logAnalyticsEvent("graphql_network_error", {
        networkError
      });
      // eslint-disable-next-line no-console
      console.log(`[Network error]: ${networkError}`);
    }
  });
